
import CrmRelative from './CrmRelative';
import arrayMixin from './arrayMixin';

export default {
  name: 'CrmRelativeCell', // 相关模块CRMCell 单类型 自定义字段用
  components: {
    CrmRelative: CrmRelative
  },
  mixins: [arrayMixin],
  props: {
    relation: {
      // 相关ID
      type: Object,
      default: function _default() {
        return {};
      }
    },
    relativeType: String
  },
  data: function data() {
    return {
      showPopover: false, // 展示popover
      showSelectView: false, // 内容
      radio: true, // 是否单选
      relationAction: { type: 'default' }
    };
  },

  computed: {
    // 如果有相关ID  展示相关效果 例如客户下的商机和合同
    isRelationShow: function isRelationShow() {
      return this.item && this.item.data && this.item.data.relation_id;
    },
    selectedData: function selectedData() {
      var crmObj = {};
      crmObj[this.crmType] = this.dataValue;
      return crmObj;
    },
    crmType: function crmType() {
      if (this.relativeType) {
        return this.relativeType;
      }
      return this.item.data.formType;
    }
  },
  watch: {
    relation: function relation(val) {
      if (val.moduleType) {
        this.relationAction = { type: 'condition', data: val };
      } else {
        this.relationAction = { type: 'default' };
      }
    }
  },
  mounted: function mounted() {
    if (this.relation && this.relation.moduleType) {
      this.relationAction = { type: 'condition', data: this.relation };
    } else {
      this.relationAction = { type: 'default' };
    }
  },

  methods: {
    /** 选中 */
    checkInfos: function checkInfos(data) {
      this.dataValue = data.data ? data.data : [];
      this.$emit('value-change', {
        index: this.index,
        value: data.data
      });
    },

    /** 删除 */
    deleteinfo: function deleteinfo(index) {
      if (this.disabled) return;
      if (this.radio && this.$refs.crmrelative) {
        // 如果单选告知删除
        this.$refs.crmrelative.clearAll();
      }
      if (this.dataValue.length === 1) {
        this.dataValue = [];
      } else {
        this.dataValue.splice(index, 1);
      }

      this.$emit('value-change', {
        index: this.index,
        value: this.dataValue
      });
    },
    contentClick: function contentClick() {
      this.showSelectView = true;
    },
    getShowName: function getShowName(data) {
      if (this.crmType === 'receivables') {
        return data.number || data.name;
      } else if (this.crmType === 'customer') {
        return data.customer_name || data.name;
      } else if (this.crmType === 'business') {
        return data.business_name || data.name;
      } else if (this.crmType === 'contract') {
        return data.contractNum || data.num;
      }
      return data.name;
    }
  }
};